<template>
  <section class="personal-center-panel">
    <h2>概览</h2>
    <div class="profile-cards">
      <article>
        <strong>会员状态</strong>
        <span>{{ front.membershipStatusLabel }}</span>
      </article>
      <article>
        <strong>已绑定分会</strong>
        <span>{{ front.boundBranchCount }} 个</span>
      </article>
      <article>
        <strong>进行中会议</strong>
        <span>{{ ongoingConferenceCount }} 场</span>
      </article>
      <article>
        <strong>未读通知</strong>
        <span>{{ front.unreadNotificationCount }} 条</span>
      </article>
    </div>
    <button type="button" class="primary-action compact" @click="front.loadSelfService">刷新我的数据</button>
  </section>
</template>

<script>
export default {
  name: 'PersonalOverviewPanel',
  inject: ['front'],
  computed: {
    ongoingConferenceCount() {
      return this.front.myRegistrationSummaries.filter(item => !item.voided).length
    }
  }
}
</script>
